import { render, staticRenderFns } from "./Bayar.vue?vue&type=template&id=de54353e"
import script from "./Bayar.vue?vue&type=script&lang=js"
export * from "./Bayar.vue?vue&type=script&lang=js"
import style0 from "./Bayar.vue?vue&type=style&index=0&id=de54353e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports